/**
 * The steps of a check: the tour of what changed, when it ran with steps, each
 * with the screenshot its flow names (else the screenshot titled for it). With
 * `flows`, a check that ran no tour lists its checked flows instead.
 */
export function qaStepsOf(report, options = {}) {
    const screenshots = report.captures.filter((capture) => capture.kind === "screenshot");
    const byId = new Map(screenshots.map((capture) => [capture.id, capture]));
    const flows = report.flows ?? [];
    const tour = report.changeTour?.ran ? report.changeTour.steps : [];
    if (tour.length > 0) {
        return tour.map((step) => {
            const prefix = `Step ${step.index}: `;
            const flow = flows.find((entry) => entry.action.startsWith(prefix));
            const screenshot = (flow?.screenshotId ? byId.get(flow.screenshotId) : undefined) ??
                screenshots.find((capture) => capture.title.startsWith(prefix)) ??
                null;
            return {
                index: step.index,
                caption: step.caption,
                outcome: step.outcome,
                atSeconds: Number.isFinite(step.atSeconds) ? step.atSeconds : null,
                ...(step.note ? { note: step.note } : {}),
                screenshot,
            };
        });
    }
    if (!options.flows)
        return [];
    return flows.map((flow, position) => ({
        index: position + 1,
        caption: flow.action,
        outcome: flow.assertion,
        atSeconds: typeof flow.timestampSeconds === "number" && Number.isFinite(flow.timestampSeconds)
            ? flow.timestampSeconds
            : null,
        ...(flow.assertion === "failed" && flow.observed ? { note: flow.observed } : {}),
        screenshot: (flow.screenshotId ? byId.get(flow.screenshotId) : undefined) ?? null,
    }));
}
/** The check's recording: the tour of what changed stores its video first. */
export function qaVideoOf(report) {
    return report.captures.find((capture) => capture.kind === "video") ?? null;
}
/** Two spellings of one commit: equal, or one the other's abbreviation (7 characters at least). */
export function sameCommit(a, b) {
    if (!a || !b)
        return false;
    const left = a.trim().toLowerCase();
    const right = b.trim().toLowerCase();
    if (left.length < 7 || right.length < 7)
        return false;
    return left.startsWith(right) || right.startsWith(left);
}
/** Whether the check tested the pull request's head as it is now; null when either side is unknown. */
export function qaCheckOnCurrentHead(check) {
    if (!check.headSha || !check.currentHeadSha)
        return null;
    return sameCommit(check.headSha, check.currentHeadSha);
}
//# sourceMappingURL=qaCheck.js.map